import type { AdditionalExpense, CalculatorInput, ExpenseTreatment } from "../server/types.js";

export const expenseTreatmentLabels: Record<ExpenseTreatment, string> = {
  "outside-price": "Сверх цены квартиры",
  "price-outside-ddu": "В цене квартиры, вне ДДУ",
  "inside-ddu": "Внутри ДДУ (уже в цене)"
};

export function purchaseExpenseTreatment(input: Partial<CalculatorInput>): ExpenseTreatment {
  return input.extraPurchaseTreatment || (input.extraPurchaseIncluded ? "inside-ddu" : "outside-price");
}

export function beforeRentExpenseTreatment(input: Partial<CalculatorInput>): ExpenseTreatment {
  return input.extraBeforeRentTreatment || "outside-price";
}

// Absent arrays identify older v2 snapshots/requests. Never count both formats.
export function additionalExpenses(input: Partial<CalculatorInput>): AdditionalExpense[] {
  return input.additionalExpenses ?? [
    { name: input.extraPurchaseName || "Дополнительный расход при покупке", amount: Number(input.extraPurchaseAmount || 0), phase: "purchase", treatment: purchaseExpenseTreatment(input), monthly: false },
    { name: input.extraBeforeRentName || "Дополнительный расход до аренды", amount: Number(input.extraBeforeRentAmount || 0), phase: "before-rent", treatment: beforeRentExpenseTreatment(input), monthly: Boolean(input.extraBeforeRentMonthly) },
    { name: input.extraAfterRentName || "Дополнительный расход после сдачи", amount: Number(input.extraAfterRentAmount || 0), phase: "after-rent", treatment: "outside-price", monthly: Boolean(input.extraAfterRentMonthly) }
  ];
}

export function expenseTotal(input: Partial<CalculatorInput>, phase: AdditionalExpense["phase"], months: number, treatment?: ExpenseTreatment) {
  return additionalExpenses(input).filter(expense => expense.phase === phase && (treatment ? expense.treatment === treatment : expense.treatment !== "inside-ddu"))
    .reduce((total,expense) => total + expense.amount * (expense.monthly ? months : 1),0);
}
